import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CustomMUIButton } from '../../../../buttons/CustomMUIButton';
import { AccountSettingRouteNames, ButtonClassNames, GlobalRouteNames } from '../../../../../../models/Common';
import { openInSameTab } from '../../../../../../services/domService';
import { usePlaton } from '../../../../../../hooks/usePlaton';

interface AddNewCardProps {
  handleClose: () => void;
}

const regularPaymentUrl = `${process.env.REACT_APP_HOME || ''}${GlobalRouteNames.AccountSettingPage}${
  AccountSettingRouteNames.AutoReplenishmentPage
}`;

export const AddNewCard: FC<AddNewCardProps> = ({ handleClose }) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const { setPlatonData, getLinkToPlatonFormAPI, reFetchPlatonAPI, isPlatonError } = usePlaton();

  const handleAddNewCard = () => {
    setIsLoading(true);
    setPlatonData({
      description: t('accountSettings.addingAPaymentCard'),
      url: regularPaymentUrl,
      error_url: regularPaymentUrl,
      source: process.env.REACT_APP_HOME || '',
      amount: 1,
      order: '',
      saveCard: 1,
    });
    reFetchPlatonAPI({
      description: t('accountSettings.addingAPaymentCard'),
      url: regularPaymentUrl,
      error_url: regularPaymentUrl,
      source: process.env.REACT_APP_HOME || '',
      amount: 1,
      order: '',
      saveCard: 1,
    });
  };

  useEffect(() => {
    if (isPlatonError) {
      setIsLoading(false);
    }
    if (getLinkToPlatonFormAPI) {
      setIsLoading(false);
      openInSameTab(getLinkToPlatonFormAPI.short_link);
    }
  }, [getLinkToPlatonFormAPI]);

  return (
    <div className="modals">
      <div className="modals__header">
        <article className="modals__header__title">{t('common.attention')}</article>
        <p className="modals__header__description">{t('accountSettings.toValidateCard')}</p>
      </div>
      <div className="modals__btn-group">
        <CustomMUIButton
          label={t('buttons.continue')}
          handleClick={handleAddNewCard}
          className={ButtonClassNames.PrimaryFulfilled}
          isBold
          isLoading={isLoading}
        />
        <CustomMUIButton
          label={t('buttons.cancel')}
          handleClick={handleClose}
          className={ButtonClassNames.SecondaryOutlined}
          isBold
          isDisabled={isPlatonError}
        />
      </div>
    </div>
  );
};
